import React, { useEffect, useState } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import {
    Button,
    TextField,
    CircularProgress,
    DialogTitle,
    DialogContent,
    Dialog,
    Stack,
    Box,
    Typography, Autocomplete
} from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {useGetDipProgById, useUpdateDipProg} from './Services';
import {DipProg} from './types';
import { format } from 'date-fns';
import {useGetDipendenti, useGetNodi, useGetProgetti} from "../gestversore/Services";
import {useGetDropProgettiByRef} from "../../common/Services";

interface EditDipProgProps {
  onClose: () => void;
  idprop: string;
}

const EditDipProg: React.FC<EditDipProgProps> = ({ onClose, idprop }) => {
    const validationSchema = Yup.object().shape({
        // id: Yup.number(), // optional number field
        ditta: Yup.number(),
        coddip: Yup.string(),
        codprog: Yup.string(),
        molt: Yup.number().transform((_, originalValue) => originalValue ? parseFloat(originalValue.toString().replace(',', '.')): undefined)
                .typeError('Inserire un numero valido'),
    })

  const { control, handleSubmit, formState: { errors }, setValue, reset,watch } = useForm<DipProg>({resolver: yupResolver(validationSchema),});

  console.log(errors);

  const { data: DipProgData, isError, isFetching } = useGetDipProgById(idprop);

  const { mutateAsync: updateDipProg, isPending: isUpdatingDipProg } = useUpdateDipProg();

 const { data: DropProgettiApiResponse } = useGetDropProgettiByRef();
  // const {  data: ProgettiApiResponse } = useGetProgetti(2);

  const {  data: DipendentiApiResponse } = useGetDipendenti(2,'');



const { data: NodiApiResponse, refetch: refetchNodi } = useGetNodi(idprop || "");

useEffect(() => {
  if (DipProgData) {

    reset({
      ditta: DipProgData.ditta ?? 2,
      coddip: DipProgData.coddip?.trim() ?? "",
      codprog: DipProgData.codprog?.trim() ?? "",
      molt: DipProgData.molt ?? 1,
    });
  }
}, [DipProgData, reset]);



  const formatDate = (date: Date | null | undefined) =>
    date ? format(new Date(date), 'yyyy-MM-dd') : '';


  const onSubmit: SubmitHandler<DipProg> = async (data) => {
    data.id = idprop;
    await updateDipProg(data);
    onClose();
  };




return (

 // <Box sx={{mt: '100px' , ml:10, width: '75%'  }}>
    <Dialog onClose={onClose} open fullWidth maxWidth="sm">
    <DialogTitle>
        <Typography variant="h5">Nuova DipProg</Typography>
    </DialogTitle>
        <DialogContent>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Stack  direction="row"  justifyContent="flex-end"  spacing={1} sx={{ mt: 2, width: '15%' }} >
                      <Controller
                        name="ditta"
                        control={control}
                        defaultValue={2}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Ditta"
                            margin="dense"
                            disabled={true}
                            fullWidth
                          />
                        )}
                      />
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Controller
                        name="codprog"
                        control={control}
                        render={({ field }) => (
                             <Box sx={{width: '100%'}}>
                            <Autocomplete
  disablePortal
  options={DropProgettiApiResponse?.results ?? []}
  getOptionLabel={(option) => option.desprog ?? ""}
  value={
    (DropProgettiApiResponse?.results ?? []).find(
      (item) =>
        item.codprog?.trim() === (field.value ?? "").trim()
    ) ?? null
  }
  onChange={(_, value) =>
    field.onChange(value?.codprog?.trim() ?? "")
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Seleziona Progetto"
      margin="dense"
      fullWidth
    />
  )}
/>

                             </Box>
                            )}
                        />
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                     <Controller
                            name="coddip"
                            control={control}
                            render={({ field }) => (
                             <Box sx={{width: '100%'}}>
                             <Autocomplete
                                  disablePortal
                                  options={DipendentiApiResponse?.results ?? []}
                                  getOptionLabel={(option) => option?.label ?? ""}
                                  onChange={(_, value) =>
                                    field.onChange(value?.coddip ?? "")
                                  }
                                  value={
                                    (DipendentiApiResponse?.results ?? []).find(
                                      (item) => item?.coddip === field.value
                                    ) ?? null
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Seleziona Dip"
                                      margin="dense"
                                      fullWidth
                                    />
                                  )}
                                />
                             </Box>
                            )}
                        />
                    </Stack>

                    <Stack  direction="row"  justifyContent="flex-end"  spacing={1} sx={{ mt: 2, width: '15%' }} >
                      <Controller
                        name="molt"
                        control={control}
                        defaultValue={1}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Moltip.ORE"
                            margin="dense"
                            fullWidth
                          />
                        )}
                      />
                    </Stack>

                    <Stack direction="row" justifyContent="flex-end" spacing={1}
                           sx={{marginTop: '15px', width: '100%'}}>
                        <Button color="primary" type="reset" variant="outlined">CANCELLA</Button>
                        <Button variant="contained" onClick={onClose} color="error">CHIUDI</Button>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={isUpdatingDipProg}
                            startIcon={isUpdatingDipProg ? <CircularProgress color="inherit" size={25}/> : null}
                        >
                            SALVA
                        </Button>
                    </Stack>

            </form>


        </DialogContent>
    </Dialog>

  );
};

export default EditDipProg;
